import { useQuery } from "@tanstack/react-query";
import galleriesAPI from "../../api/galleries/api";

export function getQueryKey() {
  return ["galleries"];
}

export function useGetGalleries() {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: galleriesAPI.getGalleries,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
